export const environment = {
  production: true,
  apiUrl: 'https://api-staging.kontactapp.com/api',
  // publicBaseUrl: 'https://community.staging.connect.kontactapp.com', 
  publicBaseUrl: 'https://community-staging.komudu.com',
};
